import axios from 'axios';

// Serve a page from the store if it was fetched within this window, so
// re-selecting the UserList page (or paging back to a page already seen) is
// instant instead of re-hitting search-service. Writes invalidate the cache
// (see src/reducers/usersList.js), so freshly added/edited users still show.
const CACHE_TTL_MS = 300000; // 5 minutes

// Identifies a page of results by everything that affects it. isATSysAdmin is
// derived from customerId server-side, so it's intentionally excluded.
const cacheKey = params => JSON.stringify({
  customerId: params.customerId,
  product: params.product,
  locationId: params.locationId || null,
  page: params.page,
  pageSize: params.pageSize,
  sortBy: params.sortBy || null,
  search: params.search || null,
});

// Asks search-service to do the customers -> locations -> person-locations ->
// persons join, product filter, search, sort and paging server-side, and return
// a single page of users. Replaces the three full-table scans + client-side join
// that froze the UserList page.
//
// Backend contract (search-service usersList query):
//   request:  { usersList: { customerId, product, isATSysAdmin, locationId?,
//                            page, pageSize, sortBy?: { column, direction },
//                            search?: { term, column } } }
//   response: { totalRows, items: [{ personId, cognitoId, email, firstName,
//                                    lastName, suffix, isActive }] }
export default function getUsersList(config, params) {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
    'x-location-id': localStorage.getItem('locationId')
  };

  const key = cacheKey(params);

  return (dispatch, getState) => {
    const slice = getState().usersList || {};
    const entry = (slice.cache || {})[key];

    // Fresh copy already in the store: serve it directly (a synchronous
    // FULFILLED, skipping PENDING) so the grid shows instantly with no spinner.
    if (entry && (Date.now() - entry.fetchedAt) < CACHE_TTL_MS) {
      return dispatch({
        type: 'USERS_LIST_FETCH_FULFILLED',
        payload: {
          data: { items: entry.items, totalRows: entry.totalRows, fetchedAt: entry.fetchedAt }
        },
        meta: { key }
      });
    }

    // After a save the cache is cleared and bustBackend is set; send refresh so
    // the Lambda also bypasses its warm-container scan cache for this one request.
    const bust = !!slice.bustBackend;
    const requestParams = bust ? { ...params, refresh: true } : params;

    return dispatch({
      type: 'USERS_LIST_FETCH',
      payload: axios({
        method: 'post',
        url: config.postSearchService,
        headers,
        data: { usersList: requestParams }
      }),
      meta: { key, bust }
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/getUsersList.js